import {
  CloudCoverFilters,
  CloudCoverTableData,
  TBoxPlotData,
  TDropdowntData,
  TFieldList,
  TAddNoteRequest,
  TGetFieldDetailsFilters,
  TGetInspectionRequest,
  TGetReportRequest,
  TReportRequestForFieldId,
  TInspectionRequest,
  TMVPBoxPlotFilters,
  TMVPChartFilters,
  TMVPDropdownFilters,
  TMVPTableData,
  TMVPTableData2,
  TMVPTableFilters,
  TMVPTableFilters2,
  TMVPTimeSeriesPlotFilters,
  TReportData,
  TReportForField,
  TScatterPlotData,
  TTimeSeriesPlotData,
  TGetAddNote,
  TGetEmployee,
  TRequestEmployee,
  TRequestPresignedurl,
  TGetPresignedurl,
  TGetPlacesByTiles,
  TRequestPlacesByTiles,
  TRequestAdvantaPlacesByTiles,
  TGetAdvantaPlacesByTiles,
  TRequestFielLogsByFieldnumber,
  TResponseFielLogsByFieldnumber,
  TResponseCheckinhistory,
  TRequestSearchField,
  TRequestTableDataByTableType,
  TGetTableDataByTableType,
  TGetAddorEditUser,
  TAddorEditUser,
} from '../types/mvpCharts';
import { createGraphqlHeader } from '../utils/functions/headers';
import { graphQLEmptySplitApi } from './emptySplitApi';
import { subtractDays } from '../../src/utils/functions/common';

// these filters are kept null
//  people: { regionManager: null, tpm: null, fa: null, organizer: null }
//  sowingDate: { startTime: { seconds: null }, endTime: { seconds: null } }

export const MVPGraphQlService =
  graphQLEmptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getScatterPlotData: builder.query<
        TScatterPlotData,
        TMVPChartFilters
      >({
        query: ({
          startTime,
          endTime,
          commonFilters: {
            index,
            region,
            subRegion,
            cluster,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            sowingStartDate,
            sowingEndDate,
            season,
            excludeHarvestFlag,
            excludePldFlag,
          },
          tableDataType,
          daysAfterPlanting,
          wsId,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetScatterPlotDetailsForDate {
              getScatterPlotDetailsForDate(
                input: {
                  wsId: ${wsId || 1}
                  sowingDate: {
                    startTime: { seconds: ${
                      sowingEndDate
                        ? subtractDays(sowingEndDate)
                        : 0
                    } }
                    endTime: { seconds: ${
                      sowingStartDate
                        ? subtractDays(sowingStartDate)
                        : 0
                    } }
                  }
                  indexName: "${index}"
                  geography: {
                    region: "${region ? region : ''}"
                    subRegion: "${
                      subRegion ? subRegion : ''
                    }"
                    cluster: "${cluster ? cluster : ''}"
                    village: "${village ? village : ''}"
                  }
                  peopleId: {
                    regionManagerId: "${
                      regionManager ? regionManager : '0'
                    }"
                    tpmId: "${tpm ? tpm : '0'}"
                    faId: "${fa ? fa : '0'}"
                    organizerId: "${
                      organizer ? organizer : '0'
                    }"
                  }
                  cropName: "${cropType ? cropType : ''}"
                  hybridCode: "${
                    hybridType ? hybridType : ''
                  }"
                  excludeHarvestFlag:${
                    excludeHarvestFlag ?? true
                  }
                  excludePldFlag:${excludePldFlag ?? true}
                  season: "${season == 'ALL' ? '' : season}"
                  ${
                    tableDataType !== undefined
                      ? `tableDataType: ${tableDataType}`
                      : ''
                  },
                  ${
                    daysAfterPlanting !== undefined
                      ? `daysAfterPlanting: ${daysAfterPlanting}`
                      : ''
                  },
                  ${
                    startTime !== undefined &&
                    endTime !== undefined
                      ? ` timeRange: {
                            startTime: { seconds: "${startTime}" }
                            endTime: { seconds: "${endTime}" }
                           }`
                      : ''
                  },
                }
              ) {
                responseStatus {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                xAxis
                yAxis
                noDataFieldNos
              }
            }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
      }),
      getBoxPlotData: builder.query<
        TBoxPlotData,
        TMVPBoxPlotFilters
      >({
        query: ({
          startTime,
          endTime,
          xAxisType,
          commonFilters: {
            index,
            region,
            subRegion,
            cluster,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            sowingStartDate,
            sowingEndDate,
            season,
            excludeHarvestFlag,
            excludePldFlag,
          },
          tableDataType,
          daysAfterPlanting,
          wsId,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetBoxPlotDetailsForDateRange {
                GetBoxPlotDetailsForDateRange(
                  input: {
                    wsId: ${wsId || 1}
                    sowingDate: {
                      startTime: { seconds: ${
                        sowingEndDate
                          ? subtractDays(sowingEndDate)
                          : 0
                      } }
                      endTime: { seconds: ${
                        sowingStartDate
                          ? subtractDays(sowingStartDate)
                          : 0
                      } }
                    }
                    indexName: "${index}"
                    geography: {
            
                      region: "${region ? region : ''}"
                      subRegion: "${
                        subRegion ? subRegion : ''
                      }"
                      cluster: "${cluster ? cluster : ''}"
                      village: "${village ? village : ''}"
                    }
                    peopleId: {
                      regionManagerId: "${
                        regionManager ? regionManager : '0'
                      }"
                      tpmId: "${tpm ? tpm : '0'}"
                      faId: "${fa ? fa : '0'}"
                      organizerId: "${
                        organizer ? organizer : '0'
                      }"
                    }
                    cropName: "${cropType ? cropType : ''}"
                    hybridCode: "${
                      hybridType ? hybridType : ''
                    }"
                    excludeHarvestFlag:${
                      excludeHarvestFlag ?? true
                    }
                    excludePldFlag:${excludePldFlag ?? true}
                    season: "${
                      season == 'ALL' ? '' : season
                    }"
                    xAxisType: "${xAxisType}"
                     ${
                       tableDataType !== undefined
                         ? `tableDataType: ${tableDataType}`
                         : ''
                     },
                    ${
                      daysAfterPlanting !== undefined
                        ? `daysAfterPlanting: ${daysAfterPlanting}`
                        : ''
                    },
                    ${
                      startTime !== undefined &&
                      endTime !== undefined
                        ? ` timeRange: {
                              startTime: { seconds: "${startTime}" }
                              endTime: { seconds: "${endTime}" }
                            }`
                        : ''
                    },
                  }
                ) {
                    responseStatus {
                      status
                      statusReason
                      errorCode
                      reasons
                      errorMessages
                      internalErrorCode
                    }
                    xAxis
                    yAxisJson
                    filteredFieldNos
                    xAxisTypeName
                    noDataFieldNos
                    boxplotDetails {
                      xAxisValue
                      median
                      q1
                      q3
                      upperBound
                      lowerBound
                      outliers {
                        outlierValue
                        timestampUnixUtc
                        fieldNumber
                      }
                    }
                  }
                }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
        transformResponse: (data: TBoxPlotData) => {
          return {
            ...data,
            data: {
              ...data.data,
              GetBoxPlotDetailsForDateRange: {
                ...data.data?.GetBoxPlotDetailsForDateRange,
                boxplotDetails:
                  data.data?.GetBoxPlotDetailsForDateRange?.boxplotDetails?.map(
                    (item) => ({
                      ...item,
                      median: Number(
                        item.median?.toFixed(3)
                      ),
                      q1: Number(item.q1?.toFixed(3)),
                      q3: Number(item.q3?.toFixed(3)),
                      upperBound: Number(
                        item.upperBound?.toFixed(3)
                      ),
                      lowerBound: Number(
                        item.lowerBound?.toFixed(3)
                      ),
                      outliers: item.outliers.map(
                        (outierItem) => ({
                          ...outierItem,
                          outlierValue: Number(
                            outierItem.outlierValue?.toFixed(
                              3
                            )
                          ),
                        })
                      ),
                    })
                  ),
              },
            },
          };
        },
      }),
      getTimeSeriesPlotData: builder.query<
        TTimeSeriesPlotData,
        TMVPTimeSeriesPlotFilters
      >({
        query: ({
          fieldNumber,
          startTime,
          endTime,
          selectedIndex,
          commonFilters: {
            index,
            region,
            subRegion,
            cluster,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            sowingStartDate,
            sowingEndDate,
            season,
            excludeHarvestFlag,
            excludePldFlag,
          },
          wsId,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetTimeSeriesDetailsForFieldNumber {
              GetTimeSeriesDetailsForFieldNumber(
              input: {
                wsId: ${wsId || 1}
                fieldNumber: ${fieldNumber}
                timeRange: {
                  startTime: { seconds: "${startTime}" }
                  endTime: { seconds: "${endTime}" }
                }
                sowingDate: {
                  startTime: { seconds: ${
                    sowingEndDate
                      ? subtractDays(sowingEndDate)
                      : 0
                  } }
                  endTime: { seconds: ${
                    sowingStartDate
                      ? subtractDays(sowingStartDate)
                      : 0
                  } }
                }
                indexName: "${selectedIndex}"
                geography: {

                  region: "${region ? region : ''}"
                  subRegion: "${subRegion ? subRegion : ''}"
                  cluster: "${cluster ? cluster : ''}"
                  village: "${village ? village : ''}"
                }
                peopleId: {
                  regionManagerId: "${
                    regionManager ? regionManager : '0'
                  }"
                  tpmId: "${tpm ? tpm : '0'}"
                  faId: "${fa ? fa : '0'}"
                  organizerId: "${
                    organizer ? organizer : '0'
                  }"
                }
                cropName: "${cropType ? cropType : ''}"
                hybridCode: "${
                  hybridType ? hybridType : ''
                }"
                excludeHarvestFlag:${
                  excludeHarvestFlag ?? true
                }
                excludePldFlag:${excludePldFlag ?? true}
                season: "${season == 'ALL' ? '' : season}"
                }
              ) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                  xAxis
                  yAxis
                  fieldNumbers
                }
              }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
      }),
      getTableDataForTimeRange: builder.query<
        TMVPTableData,
        TMVPTableFilters
      >({
        query: ({
          fieldNumbers,
          startTime,
          endTime,
          commonFilters: {
            index,
            sowingStartDate,
            sowingEndDate,
            region,
            subRegion,
            cluster,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            season,
            excludeHarvestFlag,
            excludePldFlag,
          },
          indexFlag,
          downloadCsv,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetTableDetailsForTimeRange {
              GetTableDetailsForTimeRange(
                input: {
                  fieldNumber: [
                    ${fieldNumbers}
                  ]
                  sowingDate: {
                    startTime: { seconds: ${
                      sowingEndDate
                        ? subtractDays(sowingEndDate)
                        : 0
                    } }
                    endTime: { seconds: ${
                      sowingStartDate
                        ? subtractDays(sowingStartDate)
                        : 0
                    } }
                  }
                  indexName: "${index}"
                  timeRange: {
                    startTime: { seconds: "${startTime}" }
                    endTime: { seconds: "${endTime}" }
                  }
                  geography: {
   
                    region: "${region ? region : ''}"
                    subRegion: "${
                      subRegion ? subRegion : ''
                    }"
                    cluster: "${cluster ? cluster : ''}"
                    village: "${village ? village : ''}"
                  }
                  peopleId: {
                    regionManagerId: "${
                      regionManager ? regionManager : '0'
                    }"
                    tpmId: "${tpm ? tpm : '0'}"
                    faId: "${fa ? fa : '0'}"
                    organizerId: "${
                      organizer ? organizer : '0'
                    }"
                  }
                  cropName: "${cropType ? cropType : ''}"
                  hybridCode: "${
                    hybridType ? hybridType : ''
                  }"
                  excludeHarvestFlag:${
                    excludeHarvestFlag ?? true
                  }
                  excludePldFlag:${excludePldFlag ?? true}
                  indexFlag: ${
                    indexFlag ? indexFlag : false
                  }
                  downloadCsv: ${
                    downloadCsv ? downloadCsv : false
                  }
                  season: "${season == 'ALL' ? '' : season}"
                }
              ) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                  csvPresignedUrl
                  fieldDetails {
                    fieldNumber
                    registeredArea
                    isGeofenced
                    areaUnderReported
                    averageIndex
                    minIndex
                    maxIndex
                    standardDeviation
                    indexName
                    indexTime {
                      seconds
                    }
                    sowingTime {
                      seconds
                    }  
                    harvestTime {
                      seconds
                    }
                    harvestQuantity  
                    pldStatus            
                    geofenceArea
                    latestIndexValue
                    growerName
                    latestTime {
                      seconds
                      nanos
                    }
                    employeeData {
                      regionManager
                      tpm
                      fa
                      organizer
                   }
                  geographyData {
                      country
                      region
                      subRegion
                      village
                  }
                  }
                }
              }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
        transformResponse: (data: TMVPTableData) => {
          return {
            ...data,
            data: {
              ...data.data,
              GetTableDetailsForTimeRange: {
                ...data.data?.GetTableDetailsForTimeRange,
                fieldDetails:
                  data.data?.GetTableDetailsForTimeRange?.fieldDetails?.map(
                    (item) => ({
                      ...item,
                      averageIndex: Number(
                        item.averageIndex?.toFixed(3)
                      ),
                      maxIndex: Number(
                        item.maxIndex?.toFixed(3)
                      ),
                      minIndex: Number(
                        item.minIndex?.toFixed(3)
                      ),
                      standardDeviation: Number(
                        item.standardDeviation?.toFixed(3)
                      ),
                    })
                  ),
              },
            },
          };
        },
      }),
      getCloudCoverDetails: builder.query<
        CloudCoverTableData,
        CloudCoverFilters
      >({
        query: ({
          thresholdCover,
          startTime,
          endTime,
          fieldNumbers,
          commonFilters: { index, season },
          downloadCsv,
          wsId,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetFieldDetailsForFieldNumbers {
              GetFieldDetailsForFieldNumbers(
                input: {
                  wsId: ${wsId || 1}
                  fieldNumbers: [${fieldNumbers}]
                  indexName: "${index}"
                  timeRange: {
                    startTime: { seconds: "${startTime}" }
                    endTime: { seconds: "${endTime}" }
                  }
                  cloudCoverThreshold: ${
                    thresholdCover ? thresholdCover : 0
                  }
                  downloadCsv: ${
                    downloadCsv ? downloadCsv : false
                  }
                }
              ) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                  csvPresignedUrl
                  fieldDetails { 
                    fieldNumber 
                    fieldDetails { 
                      registeredArea 
                      geofenceArea 
                      areaUnderReported 
                      growerName
                      employeeData { 
                        regionManager 
                        tpm 
                        fa 
                        organizer 
                      } 
                      geographyData { 
                        country
                        region 
                        subRegion 
                        village 
                      }
                      sowingTime {
                        seconds
                      }
                       harvestTime {
                        seconds
                      }
                      harvestQuantity
                      pldStatus
                    } 
                    fieldGeomData { 
                      geometry 
                      centerLat 
                      centerLon 
                    } 
                    fieldIndexList {
                      indexName 
                      minIndex 
                      maxIndex 
                      averageIndex 
                      standardDeviation 
                      cloudCoverPercentage 
                      indexTime { 
                        seconds 
                        nanos
                      } 
                    } 
                  }
                }
              }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
      }),
      getFieldDetails: builder.query<
        TFieldList,
        TGetFieldDetailsFilters
      >({
        query: ({
          startTime,
          endTime,
          fieldNumbers,
          commonFilters: { index, season },
          wsId,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetFieldDetailsForFieldNumbers {
              GetFieldDetailsForFieldNumbers(
                input: {
                  wsId: ${wsId || 1}
                  fieldNumbers: [${fieldNumbers}]
                  indexName: "${index}"
                  timeRange: {
                    startTime: { seconds: "${startTime}" }
                    endTime: { seconds: "${endTime}" }
                  }
                }
              ) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                   fieldDetails { 
                    fieldNumber 
                    fieldDetails { 
                      registeredArea 
                      geofenceArea 
                      areaUnderReported 
                      growerName
                      employeeData { 
                        regionManager 
                        tpm 
                        fa 
                        organizer 
                      } 
                      geographyData { 
                        country
                        region 
                        subRegion 
                        village 
                      }
                      sowingTime {
                        seconds
                      }
                       harvestTime {
                        seconds
                      }
                      harvestQuantity
                      pldStatus
                    } 
                    fieldGeomData { 
                      geometry 
                      centerLat 
                      centerLon 
                    } 
                    fieldIndexList {
                      indexName 
                      minIndex 
                      maxIndex 
                      averageIndex 
                      standardDeviation 
                      cloudCoverPercentage 
                      indexTime { 
                        seconds 
                        nanos
                      } 
                    } 
                  }
                }
              }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
      }),

      getTableDataForTimeRangeV2: builder.query<
        TMVPTableData2,
        TMVPTableFilters2
      >({
        query: ({
          daysAfterPlanting,
          tabContext,
          tableDataType,
          tablePageSize,
          tablePageNumber,
          percentileRange,
          commonFilters: {
            index,
            sowingStartDate,
            sowingEndDate,

            region,
            subRegion,
            cluster,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            season,
            excludeHarvestFlag,
            excludePldFlag,
          },
          indexFlag,
          downloadCsv,
          startTime,
          endTime,
          wsId,
        }) => ({
          url: '',
          method: 'POST',
          data: {
            query: `query GetTableDetailsV2 {
              GetTableDetailsV2(
                  input: {
                  wsId: ${wsId || 1}
                  ${
                    daysAfterPlanting !== undefined
                      ? `daysAfterPlanting: ${daysAfterPlanting}`
                      : ''
                  },
                   ${
                     startTime !== undefined &&
                     endTime !== undefined
                       ? ` timeRange: {
                            startTime: { seconds: "${startTime}" }
                            endTime: { seconds: "${endTime}" }
                           }`
                       : ''
                   },
                  ${
                    percentileRange?.minPercentile !==
                      undefined &&
                    percentileRange?.maxPercentile !==
                      undefined
                      ? `percentileRange:{
                          minPercentile:${percentileRange?.minPercentile},
                          maxPercentile:${percentileRange?.maxPercentile},
                       } `
                      : ''
                  }
                  tabContext:${tabContext},
                  tableDataType:${tableDataType},
                  tablePageSize:${tablePageSize},
                  tablePageNumber:${tablePageNumber},
                  sowingDate: {
                    startTime: { seconds: ${
                      sowingEndDate
                        ? subtractDays(sowingEndDate)
                        : 0
                    } }
                    endTime: { seconds: ${
                      sowingStartDate
                        ? subtractDays(sowingStartDate)
                        : 0
                    } }
                  }
                  indexName: "${index}"
                  geography: {
       
                    region: "${region ? region : ''}"
                    subRegion: "${
                      subRegion ? subRegion : ''
                    }"
                    cluster: "${cluster ? cluster : ''}"
                    village: "${village ? village : ''}"
                  }
                  peopleId: {
                    regionManagerId: "${
                      regionManager ? regionManager : '0'
                    }"
                    tpmId: "${tpm ? tpm : '0'}"
                    faId: "${fa ? fa : '0'}"
                    organizerId: "${
                      organizer ? organizer : '0'
                    }"
                  }
                  cropName: "${cropType ? cropType : ''}"
                  hybridCode: "${
                    hybridType ? hybridType : ''
                  }"
                  excludeHarvestFlag:${
                    excludeHarvestFlag ?? true
                  }
                  excludePldFlag:${excludePldFlag ?? true}
                  indexFlag: ${
                    indexFlag ? indexFlag : false
                  }
                  downloadCsv: ${
                    downloadCsv ? downloadCsv : false
                  }
                  season: "${season == 'ALL' ? '' : season}"
                }
              ) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                 
                    csvPresignedUrl
                    totalCount
                    nextPageToken
                    fieldDetails {
                        fieldNumber
                        reportStatus
                        fieldDetails {
                            registeredArea
                            geofenceArea
                            areaUnderReported
                            growerName
                            employeeData {
                                regionManager
                                tpm
                                fa
                                organizer
                            }
                            geographyData {
                                region
                                subRegion
                                village
                                country
                            }
                            sowingTime {
                                seconds
                            }
                            harvestTime {
                                seconds
                            }
                            harvestQuantity
                            pldStatus
                        }
                        derivedFieldProps {
                            overallMinIndex
                            overallMaxIndex
                            overallAvgIndex
                            overallStdDev
                            dataPointsCount
                            percentileValue
                            latestIndexValue
                            latestIndexTime {
                                seconds
                            }
                        }
                    }
                }
              }`,
            variables: {},
          },
          headers: createGraphqlHeader(),
          skip: () => !index || !season,
        }),
        transformResponse: (data: TMVPTableData2) => {
          return {
            ...data,
            data: {
              ...data.data,
              GetTableDetailsV2: {
                ...data.data?.GetTableDetailsV2,
                fieldDetails:
                  data.data?.GetTableDetailsV2?.fieldDetails?.map(
                    (item) => ({
                      ...item,
                      averageIndex: Number(
                        item.derivedFieldProps.overallAvgIndex?.toFixed(
                          3
                        )
                      ),
                      maxIndex: Number(
                        item.derivedFieldProps.overallMaxIndex?.toFixed(
                          3
                        )
                      ),
                      minIndex: Number(
                        item.derivedFieldProps.overallMinIndex?.toFixed(
                          3
                        )
                      ),
                      standardDeviation: Number(
                        item.derivedFieldProps.overallStdDev?.toFixed(
                          3
                        )
                      ),
                      dataPoints: Number(
                        item.derivedFieldProps.dataPointsCount?.toFixed(
                          3
                        )
                      ),
                      percentile: Number(
                        item.derivedFieldProps.percentileValue?.toFixed(
                          3
                        )
                      ),
                      latestIndex: Number(
                        item.derivedFieldProps.latestIndexValue?.toFixed(
                          3
                        )
                      ),
                    })
                  ),
              },
            },
          };
        },
      }),
      updateDropdownHierarchy: builder.query<
        TDropdowntData,
        TMVPDropdownFilters
      >({
        query: ({
          commonFilters: {
            index,
            region,
            cluster,
            subRegion,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            sowingStartDate,
            sowingEndDate,
            season,
            excludeHarvestFlag,
            excludePldFlag,
          },
          fullHierarchy,
          wsId,
        }) => {
          const additionalFields = fullHierarchy
            ? `
              indexList
              countrySeasonMapping {
                country
                seasonList
              }
              cropList
              hybridList
              weeksOfSowing
            `
            : ``;

          return {
            url: '',
            method: 'POST',
            data: {
              query: `query UpdateDropdownHierarchy {
                    UpdateDropdownHierarchy(
                      input: {
                        wsId: ${wsId || 1}
                        sowingDate: { 
                          startTime: { seconds: ${
                            sowingEndDate
                              ? subtractDays(sowingEndDate)
                              : 0
                          } }
                          endTime: { seconds: ${
                            sowingStartDate
                              ? subtractDays(
                                  sowingStartDate
                                )
                              : 0
                          } }
                        }
                        indexName: "${index}" 
                        geography: {
                 
                          region: "${region || ''}"
                          subRegion: "${subRegion || ''}"
                          cluster: "${cluster || ''}"
                          village: "${village || ''}"
                        }
                        peopleId: { 
                          regionManagerId: "${
                            regionManager || '0'
                          }"
                          tpmId: "${tpm || '0'}"
                          faId: "${fa || '0'}"
                          organizerId: "${organizer || '0'}"
                        }
                        cropName: "${
                          cropType ? cropType : ''
                        }"
                        hybridCode: "${
                          hybridType ? hybridType : ''
                        }"
                        excludeHarvestFlag:${
                          excludeHarvestFlag ?? true
                        }
                        excludePldFlag:${
                          excludePldFlag ?? true
                        }
                        season: "${
                          season === 'ALL' ? '' : season
                        }" 
                        fullHierarchy: ${fullHierarchy}
                      }
                    ) {
                      responseStatus {
                        status
                        statusReason
                        errorCode
                        reasons
                        errorMessages
                        internalErrorCode
                      }
                      geoHierarchy {
                        data {
                          type
                          name
                        }
                        children {
                          data {
                            type
                            name
                          }
                          children {
                            data {
                              type
                              name
                            }
                            children {
                              data {
                                type
                                name
                              }
                              children {
                                data {
                                  type
                                  name
                                }
                              }
                            }
                          }
                        }
                      }
                      cropHybridList {
                        cropName
                        hybridCode
                      }
                      empHierarchy {
                        data {
                          type
                          name
                        }
                        hierarchy {
                          data {
                            type
                            name
                            id
                          }
                          hierarchy {
                            data {
                              type
                              name
                              id
                            }
                            hierarchy {
                              data {
                                type
                                name
                                id
                              }
                              hierarchy{
                                data {
                                  type
                                  name
                                  id
                              }
                              }
                               hierarchy{
                                data {
                                  type
                                  name
                                  id
                              }
                              }       
                            }
                          }
                        }
                      }
                      empHierarchyFfc{
                        data {
                          type
                          name
                        }
                        hierarchy
                        {
                          data {
                            type
                            name
                            id
                          }
                          hierarchy {
                            data {
                              type
                              name
                              id
                            }
                            hierarchy {
                              data {
                                type
                                name
                                id
                              }
                              hierarchy {
                                data {
                                  type
                                  name
                                  id
                                }
                                hierarchy{
                                  data {
                                    type
                                    name
                                    id
                                }
                                }
                              }
                            }
                          }
                        }
                      }
                      ${additionalFields}
                    }
                  }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
            skip: () => index == '' || season == '',
          };
        },
      }),

      InsertOrUpdateRequestInspection: builder.mutation<
        TInspectionRequest,
        TGetInspectionRequest
      >({
        query: ({
          fieldNumbers,
          reqInstructions,
          assignee,
          actor,
          wsId,
        }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `mutation InsertOrUpdateRequestInspection {
                        InsertOrUpdateRequestInspection(
                          input: {
                            wsId: ${wsId || 1}
                            fieldNumbers  : ${JSON.stringify(
                              fieldNumbers
                            )}
                            reqInstructions : "${reqInstructions}"
                            ${
                              assignee
                                ? `assignee: {
                                    actorId: ${assignee.actorId}
                                    actorName: "${assignee.actorName}"
                                    actorType: ${assignee.actorType} 
                                  }`
                                : ''
                            }
                   
                            actor: {
                              actorId: ${actor.actorId}
                              actorName: "${
                                actor.actorName
                              }"
                              actorType: ${actor.actorType}
                              }
                          }
                        ) {
                          responseStatus {
                            status
                            statusReason
                            errorCode
                            reasons
                            errorMessages
                            internalErrorCode
                          }
                          updatedInspectionsCount
                          errorList{
                            fieldNo
                            errorMessage
                          }
                        }
                      }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetReportRequests: builder.query<
        TReportData,
        TGetReportRequest
      >({
        query: ({
          reportStatus,
          pageSize,
          pageNumber,
          actor,
          wsId,
        }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetReportRequests {
                        GetReportRequests(
                          input: {
                            wsId: ${wsId || 1}
                            reportStatus:${reportStatus}
                            pageSize:${pageSize},
                            pageNumber:${pageNumber},
                            ${
                              actor
                                ? `actor: {
                                    actorId: ${actor.actorId}
                                    actorName: "${actor.actorName}"
                                    actorType: ${actor.actorType} 
                                  }`
                                : ''
                            }  
                          }
                        ) {
                          responseStatus {
                            status
                            statusReason
                            errorCode
                            reasons
                            errorMessages
                            internalErrorCode
                          }
                           totalCount
                           reportInspections{
                              instructions
                              feedback
                              fieldNo
                              createdTime{
                                seconds
                              }     
                              createdActor{
                                actorId
                                actorName
                                actorType
                              }
                              geography{
                                region
                                subRegion
                                village
                                country
                              }
                              assigneeActor{
                                actorId
                                actorName
                                actorType
                              }
                              people{
                                regionManager
                                tpm
                                fa
                                organizer
                              }
                              sowingTime{
                                seconds
                              }     

                          }
                        }
                      }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetReportsForFieldNumber: builder.query<
        TReportForField,
        TReportRequestForFieldId
      >({
        query: ({
          fieldNo,
          //  reportStatuses,
          pageSize,
          pageNumber,
          actor,
        }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetReportsForFieldNumber {
                        GetReportsForFieldNumber(
                          input: {
                            fieldNo:${fieldNo}
                            actor: {
                                    actorId: ${actor.actorId}
                                    actorName: "${actor.actorName}"
                                    actorType: ${actor.actorType} 
                                  },    
                            pageSize:${pageSize}
                            pageNumber:${pageNumber},
                          }
                        ) {
                          responseStatus {
                            status
                            statusReason
                            errorCode
                            reasons
                            errorMessages
                            internalErrorCode
                          }
                           totalCount
                           fieldDetails{
                            fieldNumber
                            fieldDetails{
                            employeeData{
                              regionManager
                              tpm
                              fa
                              organizer
                              }
                            geographyData{
                              region
                              subRegion
                              village
                              country
                              }
                            }
                           }
                           reportDetails{
                            createdTime{
                              seconds
                            }
                            reportId
                            reportStatus
                            reportElements{
                              elementId
                              elementType
                              elementValue{
                                text
                                s3PresignedUrlImages
                                contentIds
                              }                         
                              createdActorTrace{
                                actorId {
                                  actorId
                                  actorName
                                  actorType
                                }
                                actorTime{
                                  seconds
                                }
                              }
                            }
                            instructions
                            createdActor{
                              actorId
                              actorName
                              actorType
                            }
                            assigneeActor{
                              actorId
                              actorName
                              actorType
                            }
                           }    
                        }
                      }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      UpdateReportForFieldNumber: builder.mutation<
        TGetAddNote,
        TAddNoteRequest
      >({
        query: ({ fieldNo, reportId, reportElement }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `mutation UpdateReportForFieldNumber {
                UpdateReportForFieldNumber(
                  input: {
                    fieldNo:${fieldNo}
                    reportId:${reportId}
                    reportElement:{
                      ${
                        reportElement.elementId
                          ? `elementId :${reportElement.elementId}`
                          : ''
                      }
                      elementType: ${
                        reportElement.elementType
                      }
                      elementValue:{
                        text : "${
                          reportElement.elementValue.text
                        }"
                        ${
                          reportElement.elementValue
                            .s3PresignedUrlImages
                            ? `s3PresignedUrlImages :${JSON.stringify(
                                reportElement.elementValue
                                  .s3PresignedUrlImages
                              )}`
                            : ''
                        }
                        ${
                          reportElement.elementValue
                            .contentList
                            ? `contentList:[${reportElement.elementValue.contentList
                                .map(
                                  (item) => `{
                                      latitude: ${item.latitude},
                                      longitude: ${item.longitude},
                                      accuracy: ${item.accuracy},
                                      contentLink: "${item.contentLink}"
                                    }`
                                )
                                .join(',')}]
`
                            : ''
                        }
                      }
                      createdActorTrace: {
                        actorId: {
                          actorId: ${
                            reportElement.createdActorTrace
                              .actorId.actorId
                          }
                          actorName : "${
                            reportElement.createdActorTrace
                              .actorId.actorName
                          }"
                          actorType: ${
                            reportElement.createdActorTrace
                              .actorId.actorType
                          }
                        }
                        actorTime: {
                          seconds: ${
                            reportElement.createdActorTrace
                              .actorTime.seconds
                          }
                        }
                      }
                    }
                  }
                ) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                  updatedElementsCount
                  updatedElementId
                }
              }`,
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetAllEmployees: builder.query<
        TGetEmployee,
        TRequestEmployee
      >({
        query: ({ empType }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetAllEmployees {
                        GetAllEmployees(
                          input: {
                            empType:${empType},
                     
                          }
                        ) {
                          responseStatus {
                            status
                            statusReason
                            errorCode
                            reasons
                            errorMessages
                            internalErrorCode
                          }
                          employees{
                            actor{
                              actorId
                              actorName
                              actorType
                            }
                            isUser
                          }         
                        }
                      }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetPresignedURL: builder.query<
        TGetPresignedurl,
        TRequestPresignedurl
      >({
        query: ({ actor, urlCount }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetPresignedURL {
                        GetPresignedURL(
                          input: {
                             actor: {
                                    actorId: ${actor.actorId}
                                    actorName: "${actor.actorName}"
                                    actorType: ${actor.actorType} 
                                  },
                               urlCount:${urlCount} 
                          }
                        ) {
                          responseStatus {
                            status
                            statusReason
                            errorCode
                            reasons
                            errorMessages
                            internalErrorCode
                          }
                          presignedUrlsWithLinks{
                            presignedUrl
                            contentLink    
                          }         
                        }
                      }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetPlacesByTiles: builder.query<
        TGetPlacesByTiles,
        TRequestPlacesByTiles
      >({
        query: ({ tileRequests }) => {
          const { env, mapTiles } = tileRequests;

          const mapTilesGQL = mapTiles
            .map(({ zoom, tileX, tileY }) => {
              return `{ zoom: ${zoom}, tileX: ${tileX}, tileY: ${tileY} }`;
            })
            .join(', ');

          return {
            url: '',
            method: 'POST',
            data: {
              query: `query getPlacesByTiles {
              getPlacesByTiles(
                input: {
                  tileRequests: [{
                    env: {
                      sourceType: ${env.sourceType}
                      namespace: ${env.namespace}
                      visibleType: ${env.visibleType}
                      client: ${env.client}
                    },
                    mapTiles: [${mapTilesGQL}],
                    tagFilterV2: {}
                  }]
                }
              ) {
                responseStatus {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                tileResponse {
                  places {
                    geometry
                    representationType
                    placeId
                    sourceId
                    version
                    deleted
                    overlap
                    sourceIdStr
                    tags {
                      placeTagName
                      placeTagPropertyName
                      placeTagPropertyValue
                      TagName
                      TagPropertyKey
                      TagPropertyValue
                      PlaceTagId
                    }
                  }
                }
              }
            }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetAdvantaPlacesByTiles: builder.query<
        TGetAdvantaPlacesByTiles,
        TRequestAdvantaPlacesByTiles
      >({
        query: ({
          tileRequests,
          fieldNumberOnly,
          commonFilters: {
            index,

            region,
            subRegion,
            cluster,
            village,
            regionManager,
            tpm,
            fa,
            organizer,
            cropType,
            hybridType,
            // sowingStartDate,
            // sowingEndDate,
            season,
            excludeHarvestFlag,
            excludePldFlag,
            weeksOfSowing,
          },
          dop,
          wsId,
        }) => {
          const { env, mapTiles } = tileRequests;

          const mapTilesGQL = mapTiles
            .map(({ zoom, tileX, tileY }) => {
              return `{ zoom: ${zoom}, tileX: ${tileX}, tileY: ${tileY} }`;
            })
            .join(', ');

          return {
            url: '',
            method: 'POST',
            data: {
              query: `query getAdvantaPlacesByTiles {
              getAdvantaPlacesByTiles(
                input: {
                  wsId: ${wsId || 1}
                  tileRequests: [{
                    env: {
                      sourceType: ${env.sourceType}
                      namespace: ${env.namespace}
                      visibleType: ${env.visibleType}
                      client: ${env.client}
                    },
                    mapTiles: [${mapTilesGQL}],
                    tagFilterV2: {}
                  }]
                  
                  indexName: "${index}"
                    ${
                      weeksOfSowing !== undefined
                        ? `weeksOfSowing: [${weeksOfSowing}]`
                        : ''
                    }
                  geography: {
      
                    region: "${region ? region : ''}"
                    subRegion: "${
                      subRegion ? subRegion : ''
                    }"
                    cluster: "${cluster ? cluster : ''}"
                    village: "${village ? village : ''}"
                  }
                  peopleId: {
                    regionManagerId: [${
                      regionManager ? regionManager : 0
                    }]
                    tpmId: [${tpm ? tpm : 0}]
                    faId: [${fa ? fa : 0}]
                    organizerId: [${
                      organizer ? organizer : 0
                    }]
                  }
                  cropName: "${cropType ? cropType : ''}"
                
                  hybridCode: ${JSON.stringify(
                    hybridType || ['']
                  )}
                 
                  excludeHarvestFlag:${
                    excludeHarvestFlag ?? true
                  }
                  excludePldFlag:${excludePldFlag ?? true}
                  season: "${season == 'ALL' ? '' : season}"
                  fieldNumberOnly:${fieldNumberOnly ?? true}
                  dop:${dop ?? -1}
                 
             
                }
              ) {
                responseStatus {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
               fieldTileResponse {
                 placeField {
                    place {
                        geometry
                        sourceId
                        placeId
                    }
                    fieldDataWf {
                        derivedFieldProps {
                          overallAvgIndex
                          weekOfSowing
                          yieldPerAcre
                        }
                        fieldDetails {
                          sowingTime {
                            seconds
                          }
                          employeeData {
                            regionManager
                            tpm
                            fa
                            organizer
                          }
                          hybridCode
                      }
                    }
                  }
               }
              }
            }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetFieldLogsByFieldNumber: builder.query<
        TResponseFielLogsByFieldnumber,
        TRequestFielLogsByFieldnumber
      >({
        query: ({ fieldNo, wsId }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `
          query GetFieldLogsByFieldNumber {
            GetFieldLogsByFieldNumber(
              input: {
                wsId: ${wsId || 1}
                fieldNo: ${fieldNo}
              }
            ) {
              responseStatus {
                status
                statusReason
                errorCode
                reasons
                errorMessages
                internalErrorCode
              }
              totalCount
              fieldAttributes {
                attType
                reportData {
                  createdTime {
                    seconds
                    nanos
                  }
                  reportId
                  reportElements {
                    elementId
                    elementType
                    createdActorTrace {
                      actorId {
                        actorId
                        actorName
                      }
                      actorTime {
                        seconds
                        nanos
                      }
                    }
                    elementValue {
                      text
                      s3PresignedUrlImages
                      contentIds
                      contentLinks
                      contentList {
                        accuracy
                      }
                    }
                  }
                  instructions
                  createdActor {
                    actorId
                    actorName
                  }
                  assigneeActor {
                    actorId
                  }
                  reportStatus
                  reportKeyHash
                }
                flData {
                  flType
                  flValue {
                    parentSeedData {
                      maleSeedList {
                        coveredAreaInAcres
                        batchNumber
                      }
                      femaleSeedList {
                        coveredAreaInAcres
                        batchNumber
                      }
                    }
                    inspVisitValue {
                      cropGrowthStage
                      inspValueList {
                        inspVisitValType
                        fieldFlagVal {
                          status
                          reason
                          type
                        }
                        manualYieldEstimateVal {
                          quantity
                        }
                        detasellingFlagVal {
                          flag
                          dateRange {
                            startTime {
                              seconds
                              nanos
                            }
                            endTime {
                              seconds
                              nanos
                            }
                          }
                          status
                        }
                        harvestDataVal {
                          batches {
                            harvestTime {
                              seconds
                              nanos
                            }
                            packageNo
                            totalQty
                            harvestedArea
                            transportNo
                            hash
                          }
                          finalBatchFlag
                          comment
                        }
                        cultMethodVal{
                          cmValue
                        }
                        prevCropVal{
                          pcValue
                        }
                        popCountVal{
                          malePopulation
                          femalePopulation
                        }
                        cropRatingVal{
                          cropRating
                        }
                        rowRatioVal{
                          rowRatioVal
                        }
                        stagVal{
                          staggeringVal
                        }
                        isoVal{
                          isolationSource
                        }
                        seedSetVal{
                          seedSetPerc
                        }
                        roughingVal{
                          roughingFlag
                        }
                        nickStatusVal{
                          nickStatus
                        }
                      }
                      imageContent {
                        contentIds
                      }
                    }
                    pldValue {
                      geometry
                      pldTime {
                        seconds
                        nanos
                      }
                      pldArea
                      status
                      approvalStatus
                      pldGeometry
                      pldPlaceId
                      auditPlaceId
                      remarks
                    }
                  }
                  flHash
                  flId
                  flTime {
                    seconds
                    nanos
                  }
                  flCreatedActor {
                    actorId
                    actorName
                  }
                  fieldNo
                }
              }
              fieldDetails {
                fieldNumber
                fieldDetails {
                  registeredArea
                  geofenceArea
                  lotNo
                }
                fieldGeomData {
                  geometry
                }
                fieldIndexList {
                  indexName
                }
                derivedFieldProps {
                  latestIndexValue
                }
                reportStatus
                maxImageCount
              }
            }
          }
        `,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetCheckInHistory: builder.query<
        TResponseCheckinhistory,
        TRequestFielLogsByFieldnumber
      >({
        query: ({ fieldNo, wsId }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `
          query GetCheckInHistory {
            GetCheckInHistory(
              input: {
                wsId: ${wsId || 1}
                fieldNo: ${fieldNo}
              }
            ) {
              responseStatus {
                status
                statusReason
                errorCode
                reasons
                errorMessages
                internalErrorCode
              }
             checkInList{
              fieldNo
              actorData{
                actorId{
                  actorName
                }
              actorTime{
                seconds
                nanos
              }
              }
             }
            
            }
          }
        `,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetSearchResults: builder.query<
        TResponseCheckinhistory,
        TRequestSearchField
      >({
        query: ({ searchTerm }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `
          query GetSearchResults {
            GetSearchResults(
              input: {
                searchTerm: "${searchTerm}"
              }
            ) {
              responseStatus {
                status
                statusReason
                errorCode
                reasons
                errorMessages
                internalErrorCode
              }
              fieldList {
                fieldNumber
                fieldDetails {
                  growerName
                  geographyData {
                    village
                  }
                }
                derivedFieldProps {
                  latestIndexValue
                }
              }
            }
          }
        `,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetTableDataByTableType: builder.query<
        TGetTableDataByTableType,
        TRequestTableDataByTableType
      >({
        query: ({
          tableType,
          pageSize,
          pageNumber,
          filter,
          wsId,
        }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetTableDataByTableType {
              GetTableDataByTableType(
                input: { 
                  wsId: ${wsId || 1}
                  tableType: ${tableType}
                  ${
                    filter
                      ? `filter: {
                        searchTerm: "${filter?.searchTerm}"
                        role: ${filter?.role}
                        function: ${filter?.functionn}
                        subFunction: ${filter?.subFunction}
                        active: ${filter?.active}                
                        }`
                      : ''
                  }
                  pageSize:${pageSize}
                  pageNumber:${pageNumber}
                }
              ) {
                status {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                totalCount
                tableMeta{
                  headers
                  activeColumn
                }
                users{
                  userDetails{
                    name
                    userId
                    ugdn
                    userType
                    userFunction 
                    userSubFunction
                    empId
                    status
                    country
                    accessExpiryTime{
                      seconds
                    }
                    mobileDetails{
                      mobileNumber 
                    }
                    emailId
                  }
                  totalUChildrenCount
                  userChildren
                  empHierarchy{
                    regionManager
                    tpm
                    fa
                    scmLead
                    productionLead
                  }
                  fieldNos
                  fieldCount
                  auditRecords{
                    previousValue
                    columnKey
                    updatedValue
                    updatedActorTrace{
                      actorId{
                        actorId
                        actorName
                      }
                      actorTime{
                        seconds
                      }
                    }
                  }
                  peopleId{
                    regionManagerId
                    tpmId 
                    faId 
                    organizerId 
                    scmId
                    plId
                  }
                }
                geographies{
                  region
                  subRegion
                  village
                  country
                  subRegionCode
                  geoId 
                  regionId
                  subRegionId
                  villageId
                  cluster
                  clusterId
                }
              }
            }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      AddOrUpdateDataByTableType: builder.mutation<
        TGetAddorEditUser,
        TAddorEditUser
      >({
        query: ({
          dataType,
          tableType,
          tableUpdateType,
          fileKey, //signed_url
          dataPayload,
          wsId,
        }) => {
          const buildUserDetails = (userDetails) => `
            ${
              userDetails.userId
                ? `userId: "${userDetails.userId}"`
                : ''
            }
            status: ${userDetails.status}
            ${
              userDetails.name
                ? `name: "${userDetails.name}"`
                : ''
            }
            ${
              userDetails.ugdn
                ? `ugdn: "${userDetails.ugdn}"`
                : ''
            }
            ${
              userDetails.mobileDetails
                ? `
                mobileDetails: {
                mobileNumber: "${userDetails.mobileDetails.mobileNumber}"
                countryCode: "${userDetails.mobileDetails.countryCode}"
              }`
                : ''
            }
            ${
              userDetails.country
                ? `country: "${userDetails.country}"`
                : ''
            }
            ${
              userDetails.userType
                ? `userType: ${userDetails.userType}`
                : ''
            }
            ${
              userDetails.userFunction
                ? `userFunction: ${userDetails.userFunction}`
                : ''
            }
            ${
              userDetails.userSubFunction
                ? `userSubFunction: ${userDetails.userSubFunction}`
                : ''
            }
            ${
              userDetails.emailId
                ? `emailId: "${userDetails.emailId}"`
                : ''
            }
            
          `;
          const buildEmpHierarchy = (empHierarchy) =>
            empHierarchy
              ? `
                empHierarchy: {
                  ${
                    empHierarchy.regionManager
                      ? `regionManager: "${empHierarchy.regionManager}"`
                      : ''
                  }
                  ${
                    empHierarchy.tpm
                      ? `tpm: "${empHierarchy.tpm}"`
                      : ''
                  }
                  ${
                    empHierarchy.fa
                      ? `fa: "${empHierarchy.fa}"`
                      : ''
                  }
                  ${
                    empHierarchy.organizer
                      ? `organizer: "${empHierarchy.organizer}"`
                      : ''
                  }
                  ${
                    empHierarchy.scmLead
                      ? `scmLead: "${empHierarchy.scmLead}"`
                      : ''
                  }
                  ${
                    empHierarchy.productionLead
                      ? `productionLead: "${empHierarchy.productionLead}"`
                      : ''
                  }
                }`
              : '';

          const buildPeopleId = (peopleId) =>
            peopleId
              ? `
                peopleId: {
                  ${
                    peopleId.regionManagerId
                      ? `regionManagerId: "${peopleId.regionManagerId}"`
                      : ''
                  }
                  ${
                    peopleId.tpmId
                      ? `tpmId: "${peopleId.tpmId}"`
                      : ''
                  }
                  ${
                    peopleId.faId
                      ? `faId: "${peopleId.faId}"`
                      : ''
                  }
                  ${
                    peopleId.organizerId
                      ? `organizerId: "${peopleId.organizerId}"`
                      : ''
                  }
                  ${
                    peopleId.scmId
                      ? `scmId: "${peopleId.scmId}"`
                      : ''
                  }
                   ${
                     peopleId.plId
                       ? `plId: "${peopleId.plId}"`
                       : ''
                   }
                
                }`
              : '';

          const userRecordArray = Array.isArray(
            dataPayload?.userRecord
          )
            ? dataPayload?.userRecord
            : dataPayload?.userRecord
            ? [dataPayload?.userRecord]
            : [];
          const userRecords = userRecordArray
            .map(
              (user) => `
                {
                  userDetails: {
                    ${buildUserDetails(user.userDetails)}
                  }
                  ${buildEmpHierarchy(user.empHierarchy)}
                  ${buildPeopleId(user.peopleId)}
                }
              `
            )
            .join(',');

          return {
            url: '',
            method: 'POST',
            data: {
              query: `
            mutation AddOrUpdateDataByTableType {
            AddOrUpdateDataByTableType(
              input: {
              ${fileKey ? `fileKey: "${fileKey}"` : ''}
              dataType: ${dataType}
              tableType: ${tableType}
              wsId: ${wsId}
              ${
                tableUpdateType
                  ? `tableUpdateType: ${tableUpdateType}`
                  : ''
              }
              ${
                dataPayload
                  ? `dataPayload: {
                ${
                  userRecords
                    ? `userRecord: [${userRecords}]`
                    : ''
                }
                ${
                  dataPayload?.geoRecord
                    ? `
                geoRecord: {
                   ${
                     dataPayload?.geoRecord.geoId
                       ? `geoId: "${dataPayload?.geoRecord.geoId}"`
                       : ''
                   } 
                  ${
                    dataPayload?.geoRecord.regionId
                      ? `regionId: "${dataPayload?.geoRecord.regionId}"`
                      : ''
                  }
                  ${
                    dataPayload?.geoRecord.subRegionId
                      ? `subRegionId: "${dataPayload?.geoRecord.subRegionId}"`
                      : ''
                  }
                  ${
                    dataPayload?.geoRecord.villageId
                      ? `villageId: "${dataPayload?.geoRecord.villageId}"`
                      : ''
                  }
                  ${
                    dataPayload?.geoRecord.clusterId
                      ? `clusterId: "${dataPayload?.geoRecord.clusterId}"`
                      : ''
                  }
                  region: "${dataPayload?.geoRecord.region}"
                  subRegion: "${
                    dataPayload?.geoRecord.subRegion
                  }"
                  cluster: "${
                    dataPayload?.geoRecord.cluster
                  }"
                  village: "${
                    dataPayload?.geoRecord.village
                  }"
                  country: "${
                    dataPayload?.geoRecord.country
                  }"
                  subRegionCode: "${
                    dataPayload?.geoRecord.subRegionCode
                  }"
                }`
                    : ''
                }
              }`
                  : ''
              }
            }
            ) {
              responseStatus {
                status
                statusReason
                errorCode
                reasons
                errorMessages
                internalErrorCode
              }
              dataType
              tableType
              insertedCount
              errorCount
              errorUrl
            }
          }
        `,
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetTableCSVPresignedURLByTableType: builder.query<
        TGetTableDataByTableType,
        TRequestTableDataByTableType
      >({
        query: ({
          tableType,
          count,
          csvFileType,
          fileKey,
          wsId,
        }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetTableCSVPresignedURLByTableType {
              GetTableCSVPresignedURLByTableType(
                input: { 
                  tableType: ${tableType}
                  wsId:${wsId}
                  ${count ? `count:${count}` : ''}
                  ${
                    csvFileType
                      ? `csvFileType:${csvFileType}`
                      : ''
                  }
                  ${fileKey ? `fileKey:"${fileKey}"` : ''}
                }
              ) {
                status {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                templateUrl
                fileUploads{
                      fileUrl
                      fileKey
                }
              }
            }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),

      GetImportFileHistory: builder.query<
        TGetTableDataByTableType,
        TRequestTableDataByTableType
      >({
        query: ({
          pageSize,
          pageNumber,
          tableType,
          wsId,
        }) => {
          return {
            url: '',
            method: 'POST',
            data: {
              query: `query GetImportFileHistory {
              GetImportFileHistory(
                input: {
                  wsId: ${wsId || 1}
                  pageSize: ${pageSize}
                  pageNumber:${pageNumber}
                  tableType: ${tableType}
                }
              ) {
                status {
                  status
                  statusReason
                  errorCode
                  reasons
                  errorMessages
                  internalErrorCode
                }
                records{
                importId
                file {
                  fileKey
                  fileUrl
                }
                totalRecords
                successRecords
                failedRecords
                errorFileUrl
                status
                importedBy{
                    actorId {
                      actorName
                      actorId 
                    }
                    actorTime{
                      seconds
                    }
                }
                }
                totalCount
               
              }
            }`,
              variables: {},
            },
            headers: createGraphqlHeader(),
          };
        },
      }),
    }),
  });

export const {
  useGetScatterPlotDataQuery,
  useGetBoxPlotDataQuery,
  useGetTimeSeriesPlotDataQuery,
  useGetTableDataForTimeRangeQuery,
  useLazyGetTableDataForTimeRangeQuery,
  useGetCloudCoverDetailsQuery,
  useLazyGetCloudCoverDetailsQuery,
  useGetFieldDetailsQuery,
  useLazyGetFieldDetailsQuery,
  useGetTableDataForTimeRangeV2Query,
  useLazyGetTableDataForTimeRangeV2Query,
  useUpdateDropdownHierarchyQuery,
  useInsertOrUpdateRequestInspectionMutation,
  useGetReportRequestsQuery,
  useGetReportsForFieldNumberQuery,
  useUpdateReportForFieldNumberMutation,
  useGetAllEmployeesQuery,
  useLazyGetAllEmployeesQuery,
  useGetPresignedURLQuery,
  useGetPlacesByTilesQuery,
  useGetAdvantaPlacesByTilesQuery,
  useLazyGetAdvantaPlacesByTilesQuery,
  useGetFieldLogsByFieldNumberQuery,
  useGetCheckInHistoryQuery,
  useGetSearchResultsQuery,
  useGetTableDataByTableTypeQuery,
  useAddOrUpdateDataByTableTypeMutation,
  useGetTableCSVPresignedURLByTableTypeQuery,
  useLazyGetTableCSVPresignedURLByTableTypeQuery,
  useGetImportFileHistoryQuery,
} = MVPGraphQlService;
